import React, { Component } from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';

import CredentialsForm from './components/CredentialsForm/';
import ChooseRole from './components/ChooseRole';
import ChooseCountry from './components/ChooseCountry';
import ChooseSectors from './components/ChooseSectors';
import ProfileForm from './components/ProfileForm';
import ChooseLifecycle from './components/ChooseLifecycle';
import ChooseServiceProviders from './components/ChooseServiceProviders';

import {
  REGISTER,
  CHOOSE_ROLE,
  CHOOSE_COUNTRY,
  CHOOSE_SECTORS,
  CHOOSE_LIFECYCLE,
  CHOOSE_SERVICE_PROVIDERS_TYPES,
  PROFILE_FORM,
  deleteState,
  ADD_SERVICE
} from './ducks';
import styles from './styles.module.scss';
import AddService from './components/AddService';

class SignUp extends Component {
  componentWillUnmount() {
    this.props.deleteState();
  }

  closeModal = () => {
    const { deleteState, closeModal } = this.props;
    deleteState();
    closeModal();
  };

  render() {
    const { steps, currentStep, data } = this.props;
    const { ...initialValues } = data;

    const shouldDisplayProgressBar =
      [
        CHOOSE_ROLE,
        CHOOSE_COUNTRY,
        CHOOSE_SECTORS,
        CHOOSE_LIFECYCLE,
        PROFILE_FORM
      ].includes(currentStep) &&
      !steps.includes(CHOOSE_SERVICE_PROVIDERS_TYPES); // we dont want users who've chosen the role `Service Provider` to see the progress bar and `CHOOSE_SERVICE_PROVIDERS_TYPES` is a step only included in the ServiceProvider role journey.

    return (
      <div className={styles.signupWrapper}>
        {currentStep === REGISTER && (
          <CredentialsForm
            closeModal={this.closeModal}
            initialValues={initialValues}
          />
        )}
        {currentStep === PROFILE_FORM && <ProfileForm />}
        {currentStep === CHOOSE_ROLE && <ChooseRole />}
        {currentStep === CHOOSE_COUNTRY && (
          <ChooseCountry closeModal={this.closeModal} />
        )}
        {currentStep === CHOOSE_SECTORS && <ChooseSectors />}
        {currentStep === CHOOSE_LIFECYCLE && <ChooseLifecycle />}
        {currentStep === CHOOSE_SERVICE_PROVIDERS_TYPES && (
          <ChooseServiceProviders />
        )}
        {currentStep === ADD_SERVICE && (
          <AddService closeModal={this.closeModal} />
        )}
        {shouldDisplayProgressBar && (
          <div className={styles.progressBar}>
            <div className={styles.active}>Welcome!</div>
            <div
              className={classnames({
                [styles.active]: [
                  CHOOSE_ROLE,
                  CHOOSE_COUNTRY,
                  CHOOSE_SECTORS,
                  CHOOSE_LIFECYCLE
                ].includes(currentStep)
              })}>
              What role do you play?
            </div>
            <div
              className={classnames({
                [styles.active]: [
                  CHOOSE_COUNTRY,
                  CHOOSE_SECTORS,
                  CHOOSE_LIFECYCLE
                ].includes(currentStep)
              })}>
              Which sectors are you interested in?
            </div>
            <div
              className={classnames({
                [styles.active]: [CHOOSE_COUNTRY].includes(currentStep)
              })}>
              Where are you based?
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { steps, currentStep } = state.signup;
  return {
    steps,
    currentStep
  };
};

const mapDispatchToProps = { deleteState };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp);
